'use es6';

import { isEmpty } from 'underscore';
import { updateSelectedFormItem } from 'FormsUI/actions/FormSelection';
import { getFormFieldGroups } from 'FormsUI/selectors/FormDefinition';
import { getSelectedFormItemType, getSelectedFormItemReference } from 'FormsUI/selectors/FormSelection';
import updateItemInArray from 'forms-utils-lib/utils/array/updateItemInArray';
import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { isRichTextInternalIdEqualFieldGroupInternalId } from 'FormsUI/utils/RichText';
function createAction(name) {
  return `@@formDragDrop/${name}`;
}
export const REORDER_RICH_TEXT = createAction('REORDER_RICH_TEXT');
export function reorderExistingRichText(formFieldGroups) {
  return {
    type: REORDER_RICH_TEXT,
    formFieldGroups
  };
}
export function reorderLinkedRichText(sourceFormFieldGroupIndex, targetFormFieldGroupIndex) {
  return (dispatch, getState) => {
    const formFieldGroups = getFormFieldGroups(getState());
    const sourceFormFieldGroup = formFieldGroups[sourceFormFieldGroupIndex];
    const targetFormFieldGroup = formFieldGroups[targetFormFieldGroupIndex];
    let content;
    if (!isEmpty(targetFormFieldGroup.richText) && !isEmpty(targetFormFieldGroup.richText.content)) {
      content = `
        ${targetFormFieldGroup.richText.content}
        ${sourceFormFieldGroup.richText.content}`.trim();

      // Change selction id if targeted rich text is currently selected
      const selectedItemType = getSelectedFormItemType(getState());
      const selectedItemReference = getSelectedFormItemReference(getState());
      if (selectedItemType === SpecialFieldTypes.RICH_TEXT && isRichTextInternalIdEqualFieldGroupInternalId(targetFormFieldGroup, selectedItemReference)) {
        dispatch(updateSelectedFormItem(SpecialFieldTypes.RICH_TEXT, sourceFormFieldGroup.richText.privateInternalId));
      }
    } else {
      content = sourceFormFieldGroup.richText.content;
    }
    const richText = Object.assign({}, sourceFormFieldGroup.richText, {
      content
    });
    const updatedSourceFormFieldGroup = Object.assign({}, sourceFormFieldGroup, {
      richText: Object.assign({}, sourceFormFieldGroup.richText, {
        content: '',
        privateInternalId: null
      })
    });
    const updatedTargetFormFieldGroup = Object.assign({}, targetFormFieldGroup, {
      richText
    });
    let newFormFieldGroups;
    newFormFieldGroups = updateItemInArray(formFieldGroups, sourceFormFieldGroupIndex, updatedSourceFormFieldGroup);
    newFormFieldGroups = updateItemInArray(newFormFieldGroups, targetFormFieldGroupIndex, updatedTargetFormFieldGroup);
    dispatch(reorderExistingRichText(newFormFieldGroups));
  };
}